var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwnerContainerBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 419,
    viewBox: "0 0 350 419",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-144 -229H494M-144 -217H494M-144 -205H494M-144 -193H494M-144 -181H494M-144 -169H494M-144 -157H494M-144 -145H494M-144 -133H494M-144 -121H494M-144 -109H494M-144 -97H494M-144 -85H494M-144 -73H494M-144 -61H494M-144 -49H494M-144 -37H494M-144 -25H494M-144 -13H494M-144 -1H494M-144 11H494M-144 23H494M-144 35H494M-144 47H494M-144 59H494M-144 71H494M-144 83H494M-144 95H494M-144 107H494M-144 119H494M-144 131H494M-144 143H494M-144 155H494M-144 167H494M-144 179H494M-144 191H494M-144 203H494M-144 215H494M-144 227H494M-144 239H494M-144 251H494M-144 263H494M-144 275H494M-144 287H494M-144 299H494M-144 311H494M-144 323H494M-144 335H494M-144 347H494M-144 359H494M-144 371H494M-144 383H494M-144 395H494M-144 407H494M-144 419H494",
    stroke: "url(#paint0_linear_530_3246)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_530_3246",
    x1: 175,
    y1: -229,
    x2: 175,
    y2: 419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02FFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02FFFF",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerContainerBg);
export default __webpack_public_path__ + "static/media/owner_container_bg.4b138181ecffbdc527199e64820085aa.svg";
export { ForwardRef as ReactComponent };